import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import SidebarNavList from './sidebar-nav-list';
import menus from './menu';

// In order to gain access to the child component instance, you need to assign it to a `ref`, so we call `useRef()` to get one
// const childRef = useRef();

class SidebarNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: -1,
            clicked: -1,
        };
        //console.log(this.state);
    }

    handleExpand(e, i, match) {
        e.preventDefault();
        
        if (this.state.clicked === -1 && match) {
            this.setState({
                active: -1,
                clicked: 1,
            });
        } else {
            this.setState({
                active: (this.state.active === i ? -1 : i),
                clicked: 1,
            });
        }
        //console.log(this.state.active + " : " + this.state.clicked);
    }

    render() {
        return (
            <ul className="nav">
                <li className="nav-header">Navigation</li>
                {menus.map((menu, i) => (
                    <Route path={menu.path} exact={menu.exact} key={i} children={({ match }) => (
                        <SidebarNavList
                            data={menu}
                            key={i}
                            expand={(e) => this.handleExpand(e, i, match)}
                            active={i === this.state.active}
                            clicked={this.state.clicked}
                        />
                    )} />
                ))}
            </ul>
        );
    }
}

export default withRouter(SidebarNav);





// WEBPACK FOOTER //
// ./src/components/admin/sidebar/sidebar-nav.js